import { z } from 'zod';
import { Combinator } from '../types';
import { useCriteriaSchema } from './useCriteria';

export const useQuerySchema = () => {
  const criteriaSchema = useCriteriaSchema();
  return z.object({
    combinator: z.nativeEnum(Combinator),
    searchQueries: z.array(criteriaSchema),
  });
};
